import { useTabNotification } from '@/hooks/useTabNotification';

/**
 * Глобальный слушатель индикации вкладки. Живёт на уровне App рядом с
 * `MercureEventsListener`. Сам «тупой»: вся логика — в хуке.
 */
export const TabNotificationListener: React.FC = () => {
  useTabNotification();

  return null;
};
